import React from "react";
import Game from "../Components/Game/Game";
import Layout from "./../Components/Layout/Layout";

const Main = (props) => {
  return (
    <Layout>
      Welcome! Make yourself at home! Be sure to Log in/Sign up, and then you
      can head over to Experiments by clicking on the navbar to start recording
      :)
     
    </Layout>
  );
};

export default Main;
